import { combineReducers } from '@reduxjs/toolkit';

import routeDetail from './routeDetail';
import filterPanel from './filterPanel';

export default combineReducers({
  routeDetail,
  filterPanel,
});
